import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const UserFilters = ({ filters, onFilterChange }) => {
  return (
    <div className="mb-6 bg-card border-2 border-border rounded-lg p-6 shadow-elevation-2">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">Filters & Search</h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div>
          <Input
            placeholder="Search users..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
          />
        </div>

        {/* Bare <select>s bypassed the Select component entirely: different
            height, different focus ring, no label, and no placeholder — so a
            filter row mixed two visual languages. */}
        <Select
          label="Role"
          value={filters?.role}
          onChange={(value) => onFilterChange('role', value)}
          placeholder="All roles"
          clearable
          options={[
            { value: 'admin', label: 'Admin' },
            { value: 'chair', label: 'Chair' },
            { value: 'organizer', label: 'Organizer' },
            { value: 'reviewer', label: 'Reviewer' },
            { value: 'author', label: 'Author' },
          ]}
        />

        <Select
          label="Status"
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
          placeholder="Any status"
          clearable
          options={[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
        />

        <Select
          label="Sort by"
          value={`${filters?.sortBy}-${filters?.sortOrder}`}
          onChange={(value) => {
            const [sortBy, sortOrder] = String(value)?.split('-');
            onFilterChange('sortBy', sortBy);
            onFilterChange('sortOrder', sortOrder);
          }}
          options={[
            { value: 'created_at-desc', label: 'Newest first' },
            { value: 'created_at-asc', label: 'Oldest first' },
            { value: 'firstName-asc', label: 'Name (A–Z)' },
            { value: 'firstName-desc', label: 'Name (Z–A)' },
            { value: 'email-asc', label: 'Email (A–Z)' },
            { value: 'email-desc', label: 'Email (Z–A)' },
          ]}
        />
      </div>
    </div>
  );
};

export default UserFilters;